import { motion } from 'motion/react';
import { format } from 'date-fns';
import { Trophy, ChevronRight } from 'lucide-react';

export const TournamentCard = ({ tournament, onClick }: { tournament: any, onClick: () => void }) => {
  const now = new Date();
  const effectiveStatus = now > new Date(tournament.endDate) ? 'completed'
    : now >= new Date(tournament.startDate) ? 'active'
    : 'upcoming';
  return (
    <motion.div
      onClick={onClick}
      className="shadow-card"
      style={{
        padding: '16px',
        borderRadius: '16px',
        borderLeft: '2.5px solid #C9A84C',
        backgroundColor: '#FFFFFF',
        cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px' }}>
            <Trophy style={{ width: '12px', height: '12px', color: '#C9A84C' }} />
            <span style={{ fontSize: '11px', fontWeight: 600, color: '#5A6672', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
              {format(new Date(tournament.startDate), 'MMM d')} – {format(new Date(tournament.endDate), 'MMM d')} · Tournament
            </span>
          </div>
          <h3 style={{ fontSize: '17px', fontWeight: 600, color: '#141A21', lineHeight: 1.2 }}>
            {tournament.name}
          </h3>
        </div>
        <span style={{
          fontSize: '10px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em',
          padding: '3px 8px', borderRadius: '5px', border: '0.5px solid #E3E7EB',
          color: effectiveStatus === 'active' ? '#141A21' : '#5A6672',
          backgroundColor: effectiveStatus === 'active' ? '#F5EDD6' : '#F7F8F9',
        }}>
          {effectiveStatus}
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '12px', borderTop: '0.5px solid #E3E7EB' }}>
        <span style={{ fontSize: '11px', fontWeight: 400, color: '#5A6672', textTransform: 'capitalize' }}>
          {tournament.format.replace(/_/g, ' ')}
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', fontWeight: 600, color: '#141A21' }}>
          Dashboard
          <ChevronRight style={{ width: '14px', height: '14px' }} />
        </span>
      </div>
    </motion.div>
  );
};
